var styles = {
  "imageContained": "Polaris-EmptyState--imageContained"
};

export { styles as default };
